import RegionList from "./RegionList";
import RegionCreate from "./RegionCreate";
import RegionEdit from "./RegionEdit";
import RegionShow from "./RegionShow";
import RegionIcon from "@mui/icons-material/SouthAmerica";

const regions = {
  list: RegionList,
  create: RegionCreate,
  edit: RegionEdit,
  show: RegionShow,
  icon: RegionIcon,
};

export default regions;
